import { render, staticRenderFns } from "./BookingEditPage.vue?vue&type=template&id=2f4df2f0&scoped=true&"
import script from "./BookingEditPage.vue?vue&type=script&lang=js&"
export * from "./BookingEditPage.vue?vue&type=script&lang=js&"
import style0 from "./BookingEditPage.vue?vue&type=style&index=0&id=2f4df2f0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f4df2f0",
  null
  
)

export default component.exports